<style scoped></style>

<template>
  <div>
    <ul v-for="(file, i) in this.value" v-bind:key="`${file}-ul`">
      <li class="flex mt-1 mb-1">
        <a
          :href="`/media/${file}`"
          target="_blank"
          class="text-blue-600 hover:text-blue-800"
          >{{ file.substring(file.lastIndexOf('/') + 1) }}</a
        >
        <button
          :aria-label="$t('form.buttons.aria_labels.delete_file')"
          class="align-middle"
          @click="
            (e) => {
              e.preventDefault();
              deleteFile(i);
            }
          "
        >
          <svg
            class="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </li>
    </ul>
    <input
      class="form-input block w-full border-gray-500 focus:border-blue-600 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
      type="file"
      max-size="5120"
      :id="id"
      :required="required"
      :multiple="multiple"
      :aria-describedby="helper ? `${id}-helper` : null"
      @change="this.addFile"
      :value="this.newFile"
      :disabled="disabled"
    />
    <input
      v-for="file in this.value"
      v-bind:key="`${file}-hidden`"
      type="hidden"
      :name="`${id}`"
      :value="file"
      :disabled="disabled"
    />
    <p v-if="newFileError" class="mt-2 text-sm text-red-600">
      {{ $t('form.file_upload_error') }}
      <br />
      {{ $t('form.file_upload_error_not_allowed') }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'FileField',
  props: {
    id: String,
    required: Boolean,
    multiple: Boolean,
    helper: String,
    initialValue: Array,
    csrftoken: String,
    formsAppOrigin: String,
    disabled: Boolean,
  },
  data() {
    return {
      value: this.initialValue,
      newFile: '',
      newFileError: false,
    };
  },
  methods: {
    async addFile(e) {
      this.newFileError = false;

      const files = e.target.files;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        const data = new FormData();
        data.append('file', file, file.name);

        const attachmentsUrl = `${this.formsAppOrigin}/attachments/create`;
        const response = await fetch(attachmentsUrl, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'X-CSRFToken': this.csrftoken,
          },
          body: data,
        });

        if (response.ok) {
          const responseData = await response.json();

          if (responseData.attachments.length > 0) {
            this.value.push(responseData.attachments[0].filename);
            this.newFile = '';
          } else {
            this.newFileError = true;
          }
        } else {
          this.newFileError = true;
        }
      }
    },
    deleteFile(i) {
      if (!window.confirm('Weet je zeker dat je dit bestand wil verwijderen')) {
        return;
      }

      this.$delete(this.value, i);
    },
  },
  watch: {
    value(newValue) {
      this.$emit('change', {
        target: { id: this.id, value: newValue },
      });
    },
  },
};
</script>
